// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".project-list[data-v-4787cf8d] {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-bottom: 2rem;\n  overflow-y: scroll;\n  height: 100%;\n}\n@media (min-width: 768px) {\n.project-list[data-v-4787cf8d] {\n    padding-left: 2rem;\n    padding-right: 2rem;\n}\n}\n.title[data-v-4787cf8d] {\n  font-size: 1.25rem;\n  color: #242424;\n}\n.subtitle[data-v-4787cf8d] {\n  color: #6b6b6b;\n}", ""]);
// Exports
module.exports = exports;
